<template>
  <section>
    <div class="tip" style="margin:0 0 0 20px">* 项目支付基本资料</div>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="项目名称">
          <el-input size="small" v-model="project.name" :disabled="true" placeholder="请输入项目名称"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="合同编号">
          <el-input size="small" v-model="form.htbh" :disabled="true" placeholder="请输入合同编号"></el-input>
        </el-form-item>
      </el-col>
    </div>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="合同造价">
          <el-input size="small" v-model="form.htzj" :disabled="true" placeholder="请输入合同造价"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="补充造价">
          <el-input size="small" v-model="form.bczj" placeholder="请输入补充造价"></el-input>
        </el-form-item>
      </el-col>
    </div>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="支付期数">
          <el-input size="small" v-model="form.zfqs" placeholder="请输入支付期数"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="本期审核造价">
          <el-input size="small" v-model="form.bqshzj" placeholder="请输入本期审核造价"></el-input>
        </el-form-item>
      </el-col>
    </div>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="本期前累计支付工程款" label-width="170px">
          <el-input size="small" v-model="form.ljzfgck" placeholder="本期前累计支付工程款"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="本期支付（支付至审核造价 %）" label-width="220px">
          <el-row :gutter="5">
            <el-col :span="11">
              <el-input size="small" v-model="form.bqzf" placeholder="本期支付"></el-input>
            </el-col>
            <el-col :span="12">
              <el-input size="small" v-model="form.zfzshzj" placeholder="支付 %"></el-input>
            </el-col>
          </el-row>
        </el-form-item>
      </el-col>
    </div>
    <div class="clear">
      <el-form-item label="选择进度款审核意见单" label-width="170px">
        <el-select @change="getApprovalData()" size="small" class="organization-select" v-model="form.pmaId"
          placeholder="请选择进度款审核意见单">
          <el-option v-for="item in moneyApprovalList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
    </div>
    <div class="clear">
      <el-form-item label="支付简注">
        <el-input type="textarea" placeholder="简注" :autosize="{ minRows: 3, maxRows: 6}" size="small" v-model="form.remark"></el-input>
      </el-form-item>
    </div>
  </section>
</template>

<script>
  export default {
    props: ['project', 'formByFather', 'userData', 'teamArr', 'projectArr'],
    data() {
      return {
        form: {},
        nowMoneyApproval: {},
        moneyApprovalList: [],
      }
    },
    mounted() {
      this.form = this.formByFather
      this.getMoneyApprovalList()
    },
    methods: {
      getApprovalData() {
        for (var i = 0; i < this.moneyApprovalList.length; i++) {
          let _item = this.moneyApprovalList[i]
          if (_item.id == this.form.pmaId) {
            this.nowMoneyApproval = _item
            return
          }
        }
      },
      // 获取项目控制单
      getMoneyApprovalList() {
        ajax.get('/gc/project/money/approval/list', {
          projectId: this.form.projectId
        }, (res) => {
          this.moneyApprovalList = res.vo.array
          for (var i = 0; i < this.moneyApprovalList.length; i++) {
            let _item = this.moneyApprovalList[i]
            _item.name = "审核意见单-" + _item.sstime
          }

          this.nowMoneyApproval = this.moneyApprovalList[0]
          this.form.pmaId = this.moneyApprovalList[0].id
        })
      },
      getFromData() {
        return this.form
      }
    },
    watch: {
      formByFather() {
        this.form = this.formByFather
      },
      nowMoneyApproval() {
        this.form.bczj = this.nowMoneyApproval.jgtz.split(",")[0] / 1
        this.form.zfqs = this.moneyApprovalList.length
        this.form.bqshzj = this.nowMoneyApproval.xj.split(",")[2] / 1
        this.form.ljzfgck = this.nowMoneyApproval.xj.split(",")[3] / 1
        this.form.bqzf = this.nowMoneyApproval.sjzf.split(",")[2] / 1
        this.form.zfzshzj = 100 * Math.floor(this.form.bqzf / this.form.bqshzj * 10000) / 10000 + "%"
      },
      form: {
        handler(newName, oldName) {
          if (this.form.bqzf && this.form.bqshzj) {
            this.form.zfzshzj = 100 * Math.floor(this.form.bqzf / this.form.bqshzj * 10000) / 10000 + "%"
          }
        },
        deep: true
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/form/createMoneyPayApproval.vue